import { createContext } from "react";
const DeliveryOffDayContext = createContext({});

export default DeliveryOffDayContext;
